const contactUs = {
    title: "Contact Us",
    desc: "Got any questions about the product? we are here to help. Chat with our expert friendly team 24/7.",
}
export default contactUs;